import script from "./Signup.vue?vue&type=script&setup=true&lang=js"
export * from "./Signup.vue?vue&type=script&setup=true&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=1ba7c524&lang=css"

const __exports__ = script;

export default __exports__